import { UpdateTypeEnum } from "@/model/data/enums/UpdateTypeEnum";
import { InstalledSoftware } from "@/model/data/InstalledSoftware";
import { GlobalStatusEnum } from "@/model/data/status/GlobalStatusEnum";
import { TagValues } from "@/model/data/Tag";
import { IsNamedSoftwareVersion, NamedSoftwareVersion } from "@/model/data/updates/NamedSoftwareVersion";
import { IFilterInstallations } from "../supportObjects/IFilterInstallations";
import { IPaginationFilter } from "../supportObjects/IPaginationFilter";
import { ConnectivityStatusEnum } from "@/model/data/status/ConnectivityStatusEnum";

export class FetchInstallationsUpdatesStatusRequestData implements IFilterInstallations, IPaginationFilter {
    // FilterInstallations
    installationNames: string[] = null;
    folderIds: number[] = null;
    branchNames: string[] = [];

    // PaginationFilters
    queryLimit: number = 0;
    offset: number = 0;
    orderBy: string[] = null;
    orderByDescending: boolean[] = null;

    // Other filters
    globalStatusFilter: GlobalStatusEnum[] = [];
    connectivityStatusFilter: ConnectivityStatusEnum[] = [];
    installationLastMessageDateRange: string[] = [];
    agentLastMessageDateRange: string[] = [];
    machineModels: string[] = null;
    tagValues: TagValues = null;
}

export class FetchInstallationsUpdatesStatusServerReqData implements IFilterInstallations, IPaginationFilter {
    // FilterInstallations
    installationNames: string[] = null;
    folderIds: number[] = null;
    branchNames: string[] = [];

    // PaginationFilters
    queryLimit: number = 0;
    offset: number = 0;
    orderBy: string[] = null;
    orderByDescending: boolean[] = null;

    // Other filters
    globalStatusFilter: GlobalStatusEnum[] = [];
    connectivityStatusFilter: ConnectivityStatusEnum[] = [];
    installationLastMessageDateRange: string[] = [];
    agentLastMessageDateRange: string[] = [];
    machineModels: string[] = null;
    tagValues: TagValues = null;
    softwareVersionFilterList: InstalledSoftware[] = [];
}

export function GetServerFetchInstallationsUpdatesStatusReqData(req: FetchInstallationsUpdatesStatusRequestData): FetchInstallationsUpdatesStatusServerReqData {
    let softwareVersionFilterList: InstalledSoftware[] = [];
    let reqProps = Object.keys(req);

    reqProps.forEach((prop) => {
        if (Array.isArray(req[prop]) && IsNamedSoftwareVersion(req[prop][0])) {
            req[prop].forEach((softwareFilter: NamedSoftwareVersion) => {
                let sw = new InstalledSoftware();

                if (Object.keys(UpdateTypeEnum).includes(softwareFilter.name)) sw.updateType = UpdateTypeEnum[softwareFilter.name];
                else sw.updateType = UpdateTypeEnum.ThirdPartySoftware;

                sw.name = softwareFilter.name;
                sw.version = softwareFilter.version;
                softwareVersionFilterList.push(sw);
            });
        }
    });

    let res: FetchInstallationsUpdatesStatusServerReqData = {
        installationNames: req.installationNames,
        folderIds: req.folderIds,
        branchNames: req.branchNames,
        globalStatusFilter: req.globalStatusFilter,
        connectivityStatusFilter: req.connectivityStatusFilter,
        queryLimit: req.queryLimit,
        offset: req.offset,
        orderBy: req.orderBy,
        orderByDescending: req.orderByDescending,
        installationLastMessageDateRange: req.installationLastMessageDateRange,
        agentLastMessageDateRange: req.agentLastMessageDateRange,
        machineModels: req.machineModels,
        tagValues: req.tagValues,
        softwareVersionFilterList: softwareVersionFilterList,
    };

    return res;
}
